import { Row } from 'react-bootstrap';

import FormField from '@components/Form/FormField';

import HouseholdEstimatedCost from './HouseholdEstimatedCost';

const HouseholdInformation = () => {
  return (
    <fieldset
      id='fset_householdInformation'
      aria-describedby='fset_householdInformationDesc'
      className='household-information-fieldset'
    >
      <legend className='text-center'>Household Information</legend>
      <Row>
        <FormField
          cols={6}
          name='household_size'
          helperText='The number of people in your home, including yourself.'
          label='Household size'
          type='number'
          inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
          required
        />
        <FormField
          cols={6}
          name='household_income'
          helperText='example: 15000 or 15,000'
          label='Household income (pre-tax)'
          prefixIcon='$'
          format='currency'
          inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
          required
        />
      </Row>

      <HouseholdEstimatedCost />
    </fieldset>
  );
};

export default HouseholdInformation;
